// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/antd/dist/reset.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/login_background.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/chat-background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* =============================================================================
   Global responsive layer
   -----------------------------------------------------------------------------
   Breakpoints (aligned with antd + the Sider's \`lg\` collapse point):
     phone   : <= 575px
     tablet  : 576px - 991px
     desktop : >= 992px

   This file adapts the shared Ant Design surface (tables, forms, grid, modals,
   drawers, cards, pagination) so individual pages do not each need bespoke
   mobile handling. Page-specific tweaks still live with their component.
   ========================================================================== */
/* -----------------------------------------------------------------------------
   1. Document — never let the page scroll sideways.
   Wide content (tables, editors) scrolls inside its own container instead.
   -------------------------------------------------------------------------- */
@media (max-width: 991px) {
  html,
  body {
    max-width: 100%;
    overflow-x: hidden;
  }
}
/* -----------------------------------------------------------------------------
   1b. Safe areas (installed home-screen app on notched iPhones).
   \`viewport-fit=cover\` in index.html lets the page paint edge to edge; these
   insets keep the actual content out from under the status bar, the notch and
   the home indicator. They resolve to 0px everywhere else, so the rules are
   harmless in a normal browser tab.
   -------------------------------------------------------------------------- */
/* Only the installed app paints behind the status bar, so only it needs the
   strip filled to match the header. Scoping this to standalone keeps the
   normal browser pages (login included) on their own background. */
@media (display-mode: standalone) {
  body {
    background-color: #001529;
  }
}
.app-header {
  padding-top: env(safe-area-inset-top);
  padding-left: max(10px, env(safe-area-inset-left));
  padding-right: max(10px, env(safe-area-inset-right));
  height: calc(50px + env(safe-area-inset-top));
  box-sizing: border-box;
}

.app-content {
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
}

.ant-layout-footer {
  padding-bottom: calc(24px + env(safe-area-inset-bottom));
}

/* Bottom sheets and drawers must clear the home indicator too. */
.ant-drawer-bottom .ant-drawer-content {
  padding-bottom: env(safe-area-inset-bottom);
}

.ant-drawer-left .ant-drawer-body {
  padding-bottom: env(safe-area-inset-bottom);
}

/* An installed app has no browser chrome to absorb an overscroll bounce. */
@media (display-mode: standalone) {
  html,
  body {
    overscroll-behavior-y: none;
  }
}
/* -----------------------------------------------------------------------------
   2. App shell
   -------------------------------------------------------------------------- */
.app-header {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 50px;
  padding: 0 10px;
  overflow: hidden;
}

/* Hamburger is desktop-hidden: the Sider is visible there. */
.app-nav-trigger {
  display: none;
}

/* \`collapsedWidth="0"\` makes antd render a floating 40px trigger tab pinned to
   the Sider's right edge. While the Sider is expanded that tab sits on top of
   the page content (over the breadcrumb) and duplicates the Sider's own bottom
   trigger — so only show it when it is actually needed to bring the collapsed
   Sider back. */
.ant-layout-sider:not(.ant-layout-sider-collapsed) .ant-layout-sider-zero-width-trigger {
  display: none;
}

.app-nav-drawer .ant-drawer-body {
  padding: 0;
  background: #001529;
}
.app-nav-drawer .ant-drawer-header {
  background: #001529;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.app-nav-drawer .ant-drawer-title,
.app-nav-drawer .ant-drawer-close {
  color: rgba(255, 255, 255, 0.88);
}

@media (max-width: 991px) {
  .app-nav-trigger {
    display: inline-flex;
  }
  /* Below \`lg\` the nav is a drawer opened from the header hamburger, so the
     Sider's own floating trigger has nothing to toggle. */
  .ant-layout-sider-zero-width-trigger {
    display: none !important;
  }
  .app-content {
    padding: 0 !important;
  }
  .ant-layout-footer {
    padding: 10px 12px;
    font-size: 12px;
  }
}
/* Header: drop the lowest-value items first as width runs out —
   the clock goes on tablets, the session countdown on phones. */
@media (max-width: 991px) {
  .app-header-clock {
    display: none !important;
  }
}
@media (max-width: 575px) {
  .app-header-session {
    display: none !important;
  }
}
/* -----------------------------------------------------------------------------
   3. Grid — stack columns that carry no explicit responsive props.
   Columns that already declare \`xs\`/\`sm\`/\`md\` are left untouched so existing
   deliberate layouts keep winning.
   -------------------------------------------------------------------------- */
/* NOTE: \`.ant-form-item-row\` is itself an \`.ant-row\`, and a Form's
   labelCol/wrapperCol render as \`.ant-col-*\` children of it. Those must be
   excluded here or every horizontal form breaks — form label stacking is
   handled separately in section 4. */
@media (max-width: 575px) {
  .ant-row:not(.ant-form-item-row) > .ant-col:not([class*=ant-col-xs-]):not([style*=flex]) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  /* Offsets designed for a wide grid only create dead space once stacked. */
  .ant-row:not(.ant-form-item-row) > .ant-col[class*=ant-col-offset-]:not([class*=ant-col-xs-offset-]) {
    margin-inline-start: 0 !important;
  }
}
@media (min-width: 576px) and (max-width: 991px) {
  /* 6-across and tighter -> 3-across */
  .ant-row:not(.ant-form-item-row) > .ant-col-1:not([class*=ant-col-sm-]):not([class*=ant-col-md-]):not([style*=flex]) {
    flex: 0 0 33.33333333% !important;
    max-width: 33.33333333% !important;
  }
  .ant-row:not(.ant-form-item-row) > .ant-col-2:not([class*=ant-col-sm-]):not([class*=ant-col-md-]):not([style*=flex]) {
    flex: 0 0 33.33333333% !important;
    max-width: 33.33333333% !important;
  }
  .ant-row:not(.ant-form-item-row) > .ant-col-3:not([class*=ant-col-sm-]):not([class*=ant-col-md-]):not([style*=flex]) {
    flex: 0 0 33.33333333% !important;
    max-width: 33.33333333% !important;
  }
  .ant-row:not(.ant-form-item-row) > .ant-col-4:not([class*=ant-col-sm-]):not([class*=ant-col-md-]):not([style*=flex]) {
    flex: 0 0 33.33333333% !important;
    max-width: 33.33333333% !important;
  }
  /* 4- and 3-across -> 2-across */
  .ant-row:not(.ant-form-item-row) > .ant-col-5:not([class*=ant-col-sm-]):not([class*=ant-col-md-]):not([style*=flex]) {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
  .ant-row:not(.ant-form-item-row) > .ant-col-6:not([class*=ant-col-sm-]):not([class*=ant-col-md-]):not([style*=flex]) {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
  .ant-row:not(.ant-form-item-row) > .ant-col-7:not([class*=ant-col-sm-]):not([class*=ant-col-md-]):not([style*=flex]) {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
  .ant-row:not(.ant-form-item-row) > .ant-col-8:not([class*=ant-col-sm-]):not([class*=ant-col-md-]):not([style*=flex]) {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
  /* Anything narrower than half width -> full width */
  .ant-row:not(.ant-form-item-row) > .ant-col-9:not([class*=ant-col-sm-]):not([class*=ant-col-md-]):not([style*=flex]) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .ant-row:not(.ant-form-item-row) > .ant-col-10:not([class*=ant-col-sm-]):not([class*=ant-col-md-]):not([style*=flex]) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .ant-row:not(.ant-form-item-row) > .ant-col-11:not([class*=ant-col-sm-]):not([class*=ant-col-md-]):not([style*=flex]) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
/* -----------------------------------------------------------------------------
   4. Forms — labels move above their field on phones.
   -------------------------------------------------------------------------- */
@media (max-width: 575px) {
  .ant-form-horizontal .ant-form-item-row {
    flex-direction: column;
  }
  .ant-form-horizontal .ant-form-item-label {
    flex: 0 0 auto !important;
    width: 100% !important;
    max-width: 100% !important;
    text-align: left !important;
    padding: 0 0 4px !important;
  }
  .ant-form-horizontal .ant-form-item-label > label {
    height: auto;
  }
  .ant-form-horizontal .ant-form-item-label > label::after {
    display: none;
  }
  .ant-form-horizontal .ant-form-item-control {
    flex: 1 1 auto !important;
    width: 100% !important;
    max-width: 100% !important;
  }
}
/* Inline forms (filter bars) wrap instead of overflowing. */
@media (max-width: 991px) {
  .ant-form-inline {
    row-gap: 8px;
  }
  .ant-form-inline .ant-form-item {
    margin-inline-end: 8px;
  }
}
/* -----------------------------------------------------------------------------
   5. Form controls — honour hard-coded pixel widths only when they fit.
   Many pages set e.g. \`style={{ width: 300 }}\`; capping max-width lets those
   shrink on narrow screens without touching every call site.
   -------------------------------------------------------------------------- */
@media (max-width: 991px) {
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-input-number,
  .ant-input-search,
  .ant-picker,
  .ant-select,
  .ant-cascader,
  .ant-tree-select,
  .ant-mentions,
  .ant-slider,
  .ant-radio-group,
  .ant-checkbox-group,
  .ant-upload-wrapper,
  .ant-segmented {
    max-width: 100% !important;
  }
  /* Range pickers are the most common horizontal overflow source. */
  .ant-picker-range {
    width: 100% !important;
  }
}
@media (max-width: 575px) {
  /* Comfortable touch targets without inflating inline/link buttons. */
  .ant-btn:not(.ant-btn-link):not(.ant-btn-text):not(.ant-btn-sm) {
    min-height: 36px;
  }
  .ant-input,
  .ant-select-single .ant-select-selector,
  .ant-picker {
    font-size: 16px; /* prevents iOS Safari zoom-on-focus */
  }
}
/* -----------------------------------------------------------------------------
   6. Tables — scroll horizontally inside the wrapper, never the page.
   -------------------------------------------------------------------------- */
@media (max-width: 991px) {
  .ant-table-wrapper {
    max-width: 100%;
  }
  /* Safety net for tables declared without a \`scroll\` prop. */
  .ant-table-content,
  .ant-table-body {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
  }
  /* When a Table has no \`scroll.x\`, antd renders it under \`.ant-table-content\`
     and lets the columns compress to the container width — which turns into
     overlapping, unreadable text on a phone. Giving those tables their natural
     width makes them scroll horizontally like the configured ones. Tables that
     DO set \`scroll\` render under \`.ant-table-header\`/\`.ant-table-body\`, so they
     are untouched. */
  .ant-table-content > table {
    min-width: max-content;
    /* \`table-layout: fixed\` would keep the authored column widths and let the
       no-wrap cell text spill across neighbouring columns. */
    table-layout: auto !important;
  }
  .ant-table {
    font-size: 12px;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px !important;
    white-space: nowrap;
  }
  /* Row action clusters stay on one line so rows stay compact — the table
     already scrolls horizontally. \`!important\` is needed because the generic
     "wrap long toolbars" rules further down would otherwise stack them. */
  .ant-table-tbody .ant-space:not(.ant-space-vertical),
  .ant-table-tbody .ant-flex:not(.ant-flex-vertical) {
    flex-wrap: nowrap !important;
  }
  .ant-table-title,
  .ant-table-footer {
    padding: 8px !important;
  }
}
@media (max-width: 575px) {
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 6px !important;
  }
}
/* Pagination wraps and centres rather than pushing the layout wide. */
@media (max-width: 991px) {
  .ant-pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    row-gap: 8px;
  }
  .ant-pagination-total-text {
    width: 100%;
    text-align: center;
    margin-inline-end: 0;
  }
}
@media (max-width: 575px) {
  .ant-pagination-options-quick-jumper {
    display: none !important;
  }
}
/* -----------------------------------------------------------------------------
   7. Modals & drawers — full-bleed on phones.
   -------------------------------------------------------------------------- */
@media (max-width: 991px) {
  .ant-modal {
    max-width: calc(100vw - 32px) !important;
  }
}
@media (max-width: 575px) {
  .ant-modal {
    max-width: calc(100vw - 16px) !important;
    margin: 8px auto !important;
    top: 8px !important;
    padding-bottom: 8px;
  }
  .ant-modal-body {
    max-height: calc(100vh - 180px);
    overflow-y: auto;
  }
  .ant-modal-footer {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .ant-modal-footer .ant-btn {
    flex: 1 1 auto;
    margin-inline-start: 0 !important;
  }
}
/* Drawers: full width on phones, comfortable on tablets.
   \`.app-nav-drawer\` keeps its own narrow width. */
@media (max-width: 575px) {
  .ant-drawer-left:not(.app-nav-drawer) .ant-drawer-content-wrapper,
  .ant-drawer-right:not(.app-nav-drawer) .ant-drawer-content-wrapper {
    width: 100vw !important;
    max-width: 100vw !important;
  }
}
@media (min-width: 576px) and (max-width: 991px) {
  .ant-drawer-left:not(.app-nav-drawer) .ant-drawer-content-wrapper,
  .ant-drawer-right:not(.app-nav-drawer) .ant-drawer-content-wrapper {
    max-width: 90vw !important;
  }
}
/* -----------------------------------------------------------------------------
   CKEditor 4.
   Several editor configs pin a physical page width — \`width: "21cm"\` in the
   invoice, quote and template editors, \`"19cm"\` in account notes — which
   CKEditor writes as an inline style on \`.cke\`. 21cm is ~794px, so the box is
   wider than its container on any phone, and inside a drawer or a half-width
   column on a desktop too.

   \`max-width\` always wins over \`width\`, so the page width still applies
   wherever there is room for it and collapses where there is not — the
   template editors keep their document look without spilling out of the box
   everywhere else. Matching rules for the editing body live in
   public/ckeditor-content.css, which is loaded into the editor's iframe.
   -------------------------------------------------------------------------- */
.cke,
.cke_chrome,
.cke_editor {
  max-width: 100% !important;
  box-sizing: border-box;
}

.cke_inner,
.cke_top,
.cke_contents,
.cke_bottom {
  max-width: 100%;
  box-sizing: border-box;
}

/* The toolbar wraps to as many rows as it needs; it must never set a floor on
   the editor's width. */
.cke_top {
  white-space: normal;
}

/* CKEditor is usually a flex child (Form.Item content, Space, Col). Flex items
   default to \`min-width: auto\`, which stops the parent shrinking below the
   editor's intrinsic width and pushes the overflow up the tree. */
.ant-form-item-control-input-content,
.ant-col:has(> .cke),
.cke-resize-wrap {
  min-width: 0;
}

/* The elements path ("body > p > strong") in the footer can run long. */
.cke_path {
  overflow: hidden;
}

@media (max-width: 575px) {
  /* The button set is already cut down in \`compactToolbar()\`; this squeezes the
     remaining chrome so the toolbar costs one row rather than three, and the
     text area starts near the top of the box. */
  .cke_top {
    padding: 4px 4px 2px;
  }
  .cke_toolbar,
  .cke_toolgroup,
  .cke_combo {
    margin: 0 4px 2px 0;
  }
  .cke_button {
    padding: 4px 5px;
  }
  .cke_button__source_label,
  .cke_button_label {
    display: none;
  }
  /* The elements path is a desktop affordance and costs a whole row. The
     resizer stays; only the breadcrumb goes. */
  .cke_path {
    display: none;
  }
}
/* -----------------------------------------------------------------------------
   Filter bar: search on the left, a single Filter button on the right.
   Everything else lives in the modal/sheet behind that button, so the table
   keeps the vertical space that a row of wrapped selects used to eat.
   -------------------------------------------------------------------------- */
.filter-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  /* Several toolbars nest the bar inside an existing <Flex> row; these let it
     take the free space there instead of collapsing to its content width.
     Ignored when the parent is not a flex container. */
  flex: 1 1 320px;
  min-width: 0;
}
.filter-bar .filter-bar-search {
  flex: 1 1 auto;
  max-width: 420px;
}
.filter-bar .filter-bar-actions {
  flex: 0 0 auto;
  margin-left: auto;
}

/* Applied filters, one removable chip each, sitting between the bar and the
   table so what is narrowing the list is visible without opening the modal. */
.filter-bar-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin: -8px 0 12px;
}
.filter-bar-tags .ant-tag {
  margin-inline-end: 0;
}
.filter-bar-tags .filter-bar-clear {
  font-size: 12px;
}

@media (max-width: 575px) {
  .filter-bar {
    gap: 8px;
  }
  .filter-bar .filter-bar-search {
    max-width: none;
  }
}
/* Every control in the panel spans the full width so the filters line up and
   stay comfortably tappable. */
.filter-panel .filter-field-control > .ant-select,
.filter-panel .filter-field-control > .ant-picker,
.filter-panel .filter-field-control > .ant-input,
.filter-panel .filter-field-control > .ant-input-affix-wrapper,
.filter-panel .filter-field-control > .ant-input-number,
.filter-panel .filter-field-control > .ant-radio-group,
.filter-panel .filter-field-control > .ant-cascader,
.filter-panel .filter-field-control > .ant-tree-select {
  width: 100% !important;
}

/* Drawer header: the title must be allowed to shrink (and ellipsize) so the
   action buttons in \`extra\` are never pushed past the edge or overlapped.
   Actions belong in \`extra\`, never inside \`title\` — see PreviewDrawerActions. */
.ant-drawer-header:not(.app-nav-drawer .ant-drawer-header) {
  gap: 8px;
}
.ant-drawer-header:not(.app-nav-drawer .ant-drawer-header) .ant-drawer-header-title {
  min-width: 0;
  overflow: hidden;
}
.ant-drawer-header:not(.app-nav-drawer .ant-drawer-header) .ant-drawer-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-drawer-header:not(.app-nav-drawer .ant-drawer-header) .ant-drawer-extra {
  flex: 0 0 auto;
  white-space: nowrap;
}

@media (max-width: 575px) {
  .ant-drawer-header {
    padding: 12px;
  }
  .ant-drawer-body {
    padding: 16px 12px;
  }
  .ant-drawer-footer {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
}
/* -----------------------------------------------------------------------------
   8. Cards, descriptions, tabs and other content containers.
   -------------------------------------------------------------------------- */
@media (max-width: 575px) {
  .ant-card-body {
    padding: 12px !important;
  }
  .ant-card-head {
    padding: 0 12px !important;
    min-height: 44px;
  }
  .ant-card-head-wrapper {
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px 0;
  }
  /* antd truncates card titles with \`white-space: nowrap; overflow: hidden\`,
     which cuts long titles off entirely on a narrow screen. Let them wrap. */
  .ant-card-head-title {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    padding: 0;
  }
  .ant-card-head-title .ant-space {
    flex-wrap: wrap;
  }
  .ant-card-head-title .ant-typography,
  .ant-card-head-title h1,
  .ant-card-head-title h2,
  .ant-card-head-title h3,
  .ant-card-head-title h4,
  .ant-card-head-title h5 {
    white-space: normal;
    overflow-wrap: anywhere;
  }
  .ant-card-extra {
    margin-inline-start: 0;
    padding: 0;
    width: 100%;
  }
  .ant-statistic-content {
    font-size: 18px;
  }
}
/* Descriptions collapse to a single column on phones, two on tablets. */
@media (max-width: 575px) {
  .ant-descriptions-view table,
  .ant-descriptions-view tbody,
  .ant-descriptions-row {
    display: block !important;
    width: 100% !important;
  }
  .ant-descriptions-row > th,
  .ant-descriptions-row > td {
    display: block !important;
    width: 100% !important;
    padding: 8px 12px !important;
  }
  .ant-descriptions-item-label {
    font-weight: 600;
  }
}
/* Tab bars: antd already collapses overflowing tabs into a "more" dropdown,
   so only tighten the spacing here — overriding the nav wrap's overflow would
   break that measurement and let the tab list run off-screen. */
@media (max-width: 991px) {
  .ant-tabs-nav {
    max-width: 100%;
  }
  .ant-tabs-tab {
    padding: 8px 12px;
    font-size: 13px;
  }
}
/* Long inline toolbars wrap. */
@media (max-width: 991px) {
  .ant-space:not(.ant-space-vertical) {
    flex-wrap: wrap;
  }
  .ant-page-header-heading {
    flex-wrap: wrap;
    row-gap: 8px;
  }
}
/* Headings scale down so they stop forcing horizontal overflow. */
@media (max-width: 575px) {
  h1,
  .ant-typography h1 {
    font-size: 22px !important;
  }
  h2,
  .ant-typography h2 {
    font-size: 19px !important;
  }
  h3,
  .ant-typography h3 {
    font-size: 17px !important;
  }
  .ant-breadcrumb {
    font-size: 12px;
  }
  /* Long unbroken values (emails, IDs, URLs) must not widen the page. */
  .ant-descriptions-item-content,
  .ant-list-item-meta-description,
  .ant-typography {
    overflow-wrap: anywhere;
  }
}
/* Wide rich-content blocks scroll inside themselves. */
@media (max-width: 991px) {
  .ck-editor,
  .ck-editor__editable,
  .quill,
  .ql-container,
  pre,
  .ant-typography pre {
    max-width: 100% !important;
  }
  .ck.ck-toolbar {
    flex-wrap: wrap;
  }
  .editor-container_document-editor .editor-container__editor .ck.ck-editor__editable {
    min-width: 0 !important;
    max-width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 12px !important;
  }
  .main-container,
  .editor-container__editor-wrapper {
    width: 100% !important;
  }
}
/* -----------------------------------------------------------------------------
   9. Page-level containers
   -------------------------------------------------------------------------- */
.dashboard-page {
  padding: 16px 24px;
}

@media (max-width: 991px) {
  .dashboard-page {
    padding: 12px;
  }
}
@media (max-width: 575px) {
  .dashboard-page {
    padding: 10px;
  }
}
/* Title-plus-actions bars wrap instead of crushing the heading. */
@media (max-width: 991px) {
  .page-header-bar {
    flex-wrap: wrap;
    gap: 12px;
  }
}
/* -----------------------------------------------------------------------------
   10. List-page toolbars
   The primary actions on list screens each get their own full-width row on a
   phone rather than being squeezed onto one line.
   (These rules previously lived in \`<style>\` expressions that never rendered.)
   -------------------------------------------------------------------------- */
@media (max-width: 575px) {
  .add-account-btn,
  .add-contact-btn,
  .export-contacts-btn,
  .add-lead-btn,
  .send-email-btn,
  .send-whatsapp-btn,
  .add-payment-btn,
  .update-payments-btn,
  .refresh-teson-btn,
  .refresh-product-btn,
  .create-invoice-btn,
  .create-quote-btn {
    width: 100% !important;
    margin-right: 0 !important;
  }
}
/* Forms inside drawers/modals must not carry a desktop min-width. */
@media (max-width: 991px) {
  .ant-form {
    min-width: 0 !important;
  }
}
/* Headings in a wrapping toolbar should push the actions onto the next line
   rather than being squeezed into a narrow, multi-line column. */
@media (max-width: 991px) {
  .ant-flex > h1.ant-typography,
  .ant-flex > h2.ant-typography,
  .ant-flex > h3.ant-typography,
  .ant-flex > h4.ant-typography,
  .ant-flex > h5.ant-typography,
  .page-header-bar > h1.ant-typography,
  .page-header-bar > h2.ant-typography,
  .page-header-bar > h3.ant-typography {
    flex: 0 0 auto;
    max-width: 100%;
  }
}
/* -----------------------------------------------------------------------------
   11. Flex toolbars
   \`<Flex justify="space-between">\` bars pair a filter cluster with an action
   cluster. Without wrapping, the action cluster is pushed off-screen on narrow
   viewports, so allow these to wrap (containers that opt out with
   \`wrap="nowrap"\` are respected).
   -------------------------------------------------------------------------- */
@media (max-width: 991px) {
  .ant-flex-justify-space-between:not(.ant-flex-wrap-nowrap),
  .ant-flex-justify-flex-end:not(.ant-flex-wrap-nowrap),
  .ant-flex-justify-end:not(.ant-flex-wrap-nowrap),
  .ant-flex-justify-space-around:not(.ant-flex-wrap-nowrap) {
    flex-wrap: wrap;
    row-gap: 8px;
  }
}
/* On phones every horizontal Flex cluster may wrap, so trailing controls are
   never pushed off-screen. Containers that opt out (\`wrap="nowrap"\`), vertical
   stacks, and deliberate horizontal-scroll strips (kanban) are left alone. */
@media (max-width: 575px) {
  .ant-flex:not(.ant-flex-wrap-nowrap):not(.ant-flex-vertical):not([style*=overflow]) {
    flex-wrap: wrap;
    row-gap: 8px;
  }
}
/* Space items default to not shrinking, which lets a long title overflow.
   Allowing them to shrink lets the text wrap instead. */
@media (max-width: 575px) {
  .ant-space-item {
    min-width: 0;
  }
}
#components-layout-demo-side .logo {
  height: 32px;
  margin: 16px;
  background: #0050b3;
}

.removeButtonRight {
  right: 15px;
  top: 15px;
}

.site-layout .site-layout-background {
  background: #0050b3 !important;
}

.ant-menu .ant-menu-item-selected {
  background-color: #0050b3 !important;
  /*Overriden property*/
}

.ant-layout-footer {
  padding: 5px 50px;
  color: #001529;
  background-color: rgba(43, 46, 49, 0.4078431373);
}

.ant-table-thead .ant-table-cell {
  background-color: #0050b3;
  color: white;
}

.ant-table-thead th.ant-table-column-sort {
  background-color: #d0e5ff;
  color: black;
}

.ant-table-thead th.ant-table-column-has-sorters:hover {
  background-color: #d0e5ff;
  color: black;
}

.ant-notification {
  z-index: 100000 !important;
}

.ant-table-sticky-holder {
  top: 3rem !important;
}

.custom-top {
  background-color: #f0f2f5;
}

.cursor-pointer {
  cursor: pointer;
}

.login-page {
  display: flex;
  min-height: 100vh;
  font-family: "Poppins", sans-serif;
}

.login-branding-panel {
  flex: 0 0 55%;
  background: linear-gradient(135deg, rgba(0, 66, 122, 0.92) 0%, rgba(0, 27, 58, 0.97) 100%), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px;
  position: relative;
  overflow: hidden;
}
.login-branding-panel .branding-shapes {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.login-branding-panel .branding-shapes::before {
  content: "";
  position: absolute;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.03);
  top: -150px;
  left: -150px;
}
.login-branding-panel .branding-shapes::after {
  content: "";
  position: absolute;
  width: 350px;
  height: 350px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.025);
  bottom: -80px;
  right: -80px;
}
.login-branding-panel .branding-content {
  position: relative;
  z-index: 1;
  max-width: 480px;
  width: 100%;
}
.login-branding-panel .branding-logo-section {
  margin-bottom: 56px;
}
.login-branding-panel .branding-logo-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  border: 1px solid rgba(255, 255, 255, 0.15);
}
.login-branding-panel .branding-logo-icon .anticon {
  font-size: 32px;
  color: #fff;
}
.login-branding-panel .branding-company-name {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
}
.login-branding-panel .branding-tagline {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  font-weight: 300;
}
.login-branding-panel .branding-features {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.login-branding-panel .branding-feature-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(4px);
  transition: background 0.3s ease;
}
.login-branding-panel .branding-feature-item:hover {
  background: rgba(255, 255, 255, 0.1);
}
.login-branding-panel .branding-feature-item .feature-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-branding-panel .branding-feature-item .feature-icon .anticon {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.85);
}
.login-branding-panel .branding-feature-item .feature-title {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 2px;
}
.login-branding-panel .branding-feature-item .feature-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 300;
}
.login-branding-panel .branding-footer {
  position: absolute;
  bottom: 32px;
  left: 0;
  right: 0;
  text-align: center;
}

.login-form-panel {
  flex: 0 0 45%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 60px;
  background: #f8fafc;
  position: relative;
  overflow-y: auto;
}

.login-form-container {
  width: 100%;
  max-width: 400px;
}

.login-back-btn {
  color: #64748b !important;
  padding: 0 !important;
  margin-bottom: 24px;
  font-size: 14px;
  height: auto !important;
}
.login-back-btn:hover {
  color: #0050b3 !important;
}

.login-form-header {
  margin-bottom: 32px;
}

.login-email-badge {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: #e8f4fd;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 13px;
  color: #0050b3;
  font-weight: 500;
}

.login-otp-info {
  padding: 12px 16px;
  background: #f0f7ff;
  border-radius: 8px;
  border-left: 3px solid #0050b3;
  margin-bottom: 20px;
  font-size: 13px;
  color: #334155;
}

.login-form .ant-form-item-label > label {
  font-weight: 500;
  color: #334155;
  font-size: 13px;
}

.login-input {
  height: 48px;
  border-radius: 10px;
  border: 1.5px solid #e2e8f0;
  font-size: 15px;
  transition: all 0.2s ease;
}
.login-input:hover {
  border-color: #94b8d6;
}
.login-input:focus, .login-input.ant-input-affix-wrapper-focused {
  border-color: #0050b3;
  box-shadow: 0 0 0 3px rgba(0, 80, 179, 0.08);
}
.login-input .ant-input-prefix {
  margin-right: 10px;
}

.login-otp-input {
  text-align: center;
  font-size: 22px !important;
  letter-spacing: 0.5em;
  font-weight: 600;
}

.login-submit-btn {
  height: 48px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  border-radius: 10px !important;
  background: linear-gradient(135deg, #0050b3 0%, #003175 100%) !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(0, 80, 179, 0.25) !important;
  transition: all 0.3s ease !important;
}
.login-submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #0066d6 0%, #004399 100%) !important;
  box-shadow: 0 6px 20px rgba(0, 80, 179, 0.35) !important;
  transform: translateY(-1px);
}
.login-submit-btn:active:not(:disabled) {
  transform: translateY(0);
}
.login-submit-btn:disabled {
  background: #cbd5e1 !important;
  box-shadow: none !important;
  cursor: not-allowed;
}

.login-error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 10px 16px;
  color: #dc2626;
  font-size: 13px;
  margin-bottom: 16px;
  text-align: center;
}

.login-actions {
  text-align: center;
}

.login-link {
  color: #0050b3 !important;
  font-weight: 500;
  font-size: 13px;
  padding: 4px 0 !important;
  height: auto !important;
}
.login-link:hover {
  color: #003175 !important;
}

.login-form-footer {
  text-align: center;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}

.reset-embedded {
  width: 100%;
}

.reset-step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  gap: 0;
}
.reset-step-indicator .reset-step {
  display: flex;
  align-items: center;
  gap: 6px;
}
.reset-step-indicator .reset-step .reset-step-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  background: #e2e8f0;
  color: #94a3b8;
  transition: all 0.3s ease;
}
.reset-step-indicator .reset-step .reset-step-label {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
  transition: all 0.3s ease;
}
.reset-step-indicator .reset-step .reset-step-line {
  width: 32px;
  height: 2px;
  background: #e2e8f0;
  margin: 0 8px;
  transition: all 0.3s ease;
}
.reset-step-indicator .reset-step .reset-step-line.complete {
  background: #0050b3;
}
.reset-step-indicator .reset-step.active .reset-step-dot {
  background: #0050b3;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 80, 179, 0.3);
}
.reset-step-indicator .reset-step.active .reset-step-label {
  color: #0050b3;
}
.reset-step-indicator .reset-step.complete .reset-step-dot {
  background: #0050b3;
  color: #fff;
}
.reset-step-indicator .reset-step.complete .reset-step-label {
  color: #0050b3;
}

.reset-header {
  text-align: center;
  margin-bottom: 28px;
}

.reset-icon-circle {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0050b3 0%, #003175 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}
.reset-icon-circle .anticon {
  font-size: 24px;
  color: #fff;
}
.reset-icon-circle.success {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
}

.otp-digit-input {
  width: 48px !important;
  height: 56px !important;
  text-align: center !important;
  font-size: 22px !important;
  font-weight: 700 !important;
  border-radius: 10px !important;
  border: 2px solid #e2e8f0 !important;
  transition: all 0.2s ease !important;
}
.otp-digit-input:focus {
  border-color: #0050b3 !important;
  box-shadow: 0 0 0 3px rgba(0, 80, 179, 0.1) !important;
}
.otp-digit-input:hover {
  border-color: #94b8d6 !important;
}
.otp-digit-input.otp-error {
  border-color: #ef4444 !important;
}

@media (max-width: 992px) {
  .login-branding-panel {
    flex: 0 0 45%;
    padding: 40px;
  }
  .login-branding-panel .branding-company-name {
    font-size: 28px;
  }
  .login-branding-panel .branding-logo-section {
    margin-bottom: 40px;
  }
  .login-form-panel {
    flex: 0 0 55%;
    padding: 40px;
  }
}
@media (max-width: 768px) {
  .login-page {
    flex-direction: column;
  }
  .login-branding-panel {
    flex: none;
    padding: 40px 24px;
    min-height: auto;
  }
  .login-branding-panel .branding-features {
    display: none;
  }
  .login-branding-panel .branding-logo-section {
    margin-bottom: 0;
    text-align: center;
  }
  .login-branding-panel .branding-logo-icon {
    margin: 0 auto 16px;
  }
  .login-branding-panel .branding-company-name {
    text-align: center;
  }
  .login-branding-panel .branding-tagline {
    text-align: center;
  }
  .login-branding-panel .branding-footer {
    display: none;
  }
  .login-form-panel {
    flex: 1 1;
    padding: 32px 24px;
  }
}
@media (max-width: 480px) {
  .login-form-panel {
    padding: 24px 16px;
  }
  .otp-digit-input {
    width: 40px !important;
    height: 48px !important;
    font-size: 18px !important;
  }
}
/* Style the scrollbar for a specific div */
.custom-scroll-div::-webkit-scrollbar {
  width: 5px; /* Width of the vertical scrollbar */
  height: 5px; /* Height of the horizontal scrollbar */
}

.custom-scroll-div::-webkit-scrollbar-track {
  background: #f1f1f1; /* Color of the scrollbar track */
  border-radius: 5px; /* Roundness of the track (optional) */
}

.custom-scroll-div::-webkit-scrollbar-thumb {
  background: #888; /* Color of the scrollbar handle */
  border-radius: 5px; /* Roundness of the handle (optional) */
}

/* Handle on hover */
.custom-scroll-div::-webkit-scrollbar-thumb:hover {
  background: #555; /* Color of the scrollbar handle on hover */
}

.chat-background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center center;
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/styles/responsive.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;;;;;+EAAA;AAiBA;;;+EAAA;AAIA;EACE;;IAEE,eAAA;IACA,kBAAA;EDDF;AACF;ACIA;;;;;;+EAAA;AAOA;;mEAAA;AAGA;EACE;IACE,yBAAA;EDFF;AACF;ACKA;EACE,qCAAA;EACA,kDAAA;EACA,oDAAA;EACA,6CAAA;EACA,sBAAA;ADHF;;ACMA;EACE,uCAAA;EACA,yCAAA;EACA,2CAAA;ADHF;;ACMA;EACE,wDAAA;ADHF;;ACMA,iEAAA;AACA;EACE,2CAAA;ADHF;;ACMA;EACE,2CAAA;ADHF;;ACMA,2EAAA;AACA;EACE;;IAEE,2BAAA;EDHF;AACF;ACMA;;+EAAA;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;ADJF;;ACOA,6DAAA;AACA;EACE,aAAA;ADJF;;ACOA;;;;gBAAA;AAKA;EAEE,aAAA;ADLF;;ACSE;EACE,UAAA;EACA,mBAAA;ADNJ;ACQE;EACE,mBAAA;EACA,kDAAA;ADNJ;ACQE;;EAEE,gCAAA;ADNJ;;ACUA;EACE;IACE,oBAAA;EDPF;ECUA;0DAAA;EAEA;IACE,wBAAA;EDRF;ECWA;IACE,qBAAA;EDTF;ECYA;IACE,kBAAA;IACA,eAAA;EDVF;AACF;ACaA;gEAAA;AAEA;EACE;IACE,wBAAA;EDXF;AACF;ACcA;EACE;IACE,wBAAA;EDZF;AACF;ACeA;;;;+EAAA;AAKA;;;qCAAA;AAIA;EACE;IAEE,yBAAA;IACA,0BAAA;EDdF;ECiBA,0EAAA;EACA;IAEE,iCAAA;EDhBF;AACF;ACmBA;EAGE,qCAAA;EAEE;IACE,iCAAA;IACA,kCAAA;EDpBJ;ECkBE;IACE,iCAAA;IACA,kCAAA;EDhBJ;ECcE;IACE,iCAAA;IACA,kCAAA;EDZJ;ECUE;IACE,iCAAA;IACA,kCAAA;EDRJ;ECYA,gCAAA;EAEE;IACE,wBAAA;IACA,yBAAA;EDXJ;ECSE;IACE,wBAAA;IACA,yBAAA;EDPJ;ECKE;IACE,wBAAA;IACA,yBAAA;EDHJ;ECCE;IACE,wBAAA;IACA,yBAAA;EDCJ;ECGA,oDAAA;EAEE;IACE,yBAAA;IACA,0BAAA;EDFJ;ECAE;IACE,yBAAA;IACA,0BAAA;EDEJ;ECJE;IACE,yBAAA;IACA,0BAAA;EDMJ;AACF;ACFA;;+EAAA;AAGA;EACE;IACE,sBAAA;EDIF;ECDA;IACE,yBAAA;IACA,sBAAA;IACA,0BAAA;IACA,2BAAA;IACA,2BAAA;EDGF;ECDE;IACE,YAAA;EDGJ;ECFI;IACE,aAAA;EDIN;ECCA;IACE,yBAAA;IACA,sBAAA;IACA,0BAAA;EDCF;AACF;ACEA,4DAAA;AACA;EACE;IACE,YAAA;EDAF;ECEE;IACE,sBAAA;EDAJ;AACF;ACIA;;;;+EAAA;AAKA;EACE;;;;;;;;;;;;;;IAcE,0BAAA;EDFF;ECKA,kEAAA;EACA;IACE,sBAAA;EDHF;AACF;ACMA;EACE,qEAAA;EACA;IACE,gBAAA;EDJF;ECOA;;;IAGE,eAAA,EAAA,sCAAA;EDLF;AACF;ACQA;;+EAAA;AAGA;EACE;IACE,eAAA;EDNF;ECSA,4DAAA;EACA;;IAEE,2BAAA;IACA,iCAAA;EDPF;ECUA;;;;;qBAAA;EAMA;IACE,sBAAA;IACA;6DAAA;IAEA,6BAAA;EDRF;ECWA;IACE,eAAA;EDTF;ECYA;;IAEE,uBAAA;IACA,mBAAA;EDVF;ECaA;;0EAAA;EAGA;;IAEE,4BAAA;EDXF;ECcA;;IAEE,uBAAA;EDZF;AACF;ACeA;EACE;;IAEE,uBAAA;EDbF;AACF;ACgBA,sEAAA;AACA;EACE;IACE,aAAA;IACA,eAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;EDdF;ECiBA;IACE,WAAA;IACA,kBAAA;IACA,oBAAA;EDfF;AACF;ACkBA;EACE;IACE,wBAAA;EDhBF;AACF;ACmBA;;+EAAA;AAGA;EACE;IACE,wCAAA;EDjBF;AACF;ACoBA;EACE;IACE,wCAAA;IACA,2BAAA;IACA,mBAAA;IACA,mBAAA;EDlBF;ECqBA;IACE,+BAAA;IACA,gBAAA;EDnBF;ECsBA;IACE,aAAA;IACA,eAAA;IACA,QAAA;EDpBF;ECsBE;IACE,cAAA;IACA,iCAAA;EDpBJ;AACF;ACwBA;kDAAA;AAEA;EACE;;IAEE,uBAAA;IACA,2BAAA;EDtBF;AACF;ACyBA;EACE;;IAEE,0BAAA;EDvBF;AACF;AC0BA;;;;;;;;;;;;;+EAAA;AAcA;;;EAGE,0BAAA;EACA,sBAAA;ADxBF;;AC2BA;;;;EAIE,eAAA;EACA,sBAAA;ADxBF;;AC2BA;wBAAA;AAEA;EACE,mBAAA;ADxBF;;AC2BA;;kEAAA;AAGA;;;EAGE,YAAA;ADxBF;;AC2BA,wEAAA;AACA;EACE,gBAAA;ADxBF;;AC2BA;EACE;;gDAAA;EAGA;IACE,oBAAA;EDxBF;EC2BA;;;IAGE,mBAAA;EDzBF;EC4BA;IACE,gBAAA;ED1BF;EC6BA;;IAEE,aAAA;ED3BF;EC8BA;+CAAA;EAEA;IACE,aAAA;ED5BF;AACF;AC+BA;;;;+EAAA;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA;;uDAAA;EAGA,eAAA;EACA,YAAA;AD7BF;AC+BE;EACE,cAAA;EACA,gBAAA;AD7BJ;ACgCE;EACE,cAAA;EACA,iBAAA;AD9BJ;;ACkCA;8EAAA;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AD/BF;ACiCE;EACE,oBAAA;AD/BJ;ACkCE;EACE,eAAA;ADhCJ;;ACoCA;EACE;IACE,QAAA;EDjCF;ECmCE;IACE,eAAA;EDjCJ;AACF;ACqCA;+BAAA;AAII;;;;;;;;EAQE,sBAAA;ADrCN;;AC0CA;;gFAAA;AAGA;EACE,QAAA;ADvCF;ACyCE;EACE,YAAA;EACA,gBAAA;ADvCJ;AC0CE;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;ADxCJ;AC2CE;EACE,cAAA;EACA,mBAAA;ADzCJ;;AC6CA;EACE;IACE,aAAA;ED1CF;EC6CA;IACE,kBAAA;ED3CF;EC8CA;IACE,aAAA;IACA,eAAA;IACA,QAAA;ED5CF;AACF;AC+CA;;+EAAA;AAGA;EACE;IACE,wBAAA;ED7CF;ECgDA;IACE,0BAAA;IACA,gBAAA;ED9CF;ECiDA;IACE,eAAA;IACA,QAAA;IACA,cAAA;ED/CF;ECkDA;6EAAA;EAEA;IACE,mBAAA;IACA,iBAAA;IACA,mBAAA;IACA,UAAA;EDhDF;ECkDE;IACE,eAAA;EDhDJ;ECmDE;;;;;;IAME,mBAAA;IACA,uBAAA;EDjDJ;ECqDA;IACE,sBAAA;IACA,UAAA;IACA,WAAA;EDnDF;ECsDA;IACE,eAAA;EDpDF;AACF;ACuDA,wEAAA;AACA;EACE;;;IAGE,yBAAA;IACA,sBAAA;EDrDF;ECwDA;;IAEE,yBAAA;IACA,sBAAA;IACA,4BAAA;EDtDF;ECyDA;IACE,gBAAA;EDvDF;AACF;AC0DA;;gEAAA;AAGA;EACE;IACE,eAAA;EDxDF;EC2DA;IACE,iBAAA;IACA,eAAA;EDzDF;AACF;AC4DA,+BAAA;AACA;EACE;IACE,eAAA;ED1DF;EC6DA;IACE,eAAA;IACA,YAAA;ED3DF;AACF;AC8DA,kEAAA;AACA;EACE;;IAEE,0BAAA;ED5DF;EC8DA;;IAEE,0BAAA;ED5DF;EC8DA;;IAEE,0BAAA;ED5DF;EC+DA;IACE,eAAA;ED7DF;ECgEA,sEAAA;EACA;;;IAGE,uBAAA;ED9DF;AACF;ACiEA,uDAAA;AACA;EACE;;;;;;IAME,0BAAA;ED/DF;ECkEA;IACE,eAAA;EDhEF;ECmEA;IACE,uBAAA;IACA,0BAAA;IACA,yBAAA;IACA,0BAAA;IACA,wBAAA;EDjEF;ECoEA;;IAEE,sBAAA;EDlEF;AACF;ACqEA;;+EAAA;AAGA;EACE,kBAAA;ADnEF;;ACsEA;EACE;IACE,aAAA;EDnEF;AACF;ACsEA;EACE;IACE,aAAA;EDpEF;AACF;ACuEA,kEAAA;AACA;EACE;IACE,eAAA;IACA,SAAA;EDrEF;AACF;ACwEA;;;;;+EAAA;AAMA;EACE;;;;;;;;;;;;IAYE,sBAAA;IACA,0BAAA;EDtEF;AACF;ACyEA,oEAAA;AACA;EACE;IACE,uBAAA;EDvEF;AACF;AC0EA;iEAAA;AAEA;EACE;;;;;;;;IAQE,cAAA;IACA,eAAA;EDxEF;AACF;AC2EA;;;;;;+EAAA;AAOA;EACE;;;;IAIE,eAAA;IACA,YAAA;EDzEF;AACF;AC4EA;;6EAAA;AAGA;EACE;IACE,eAAA;IACA,YAAA;ED1EF;AACF;AC6EA;wDAAA;AAEA;EACE;IACE,YAAA;ED3EF;AACF;AArxBA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAuxBF;;AApxBA;EACE,WAAA;EACA,SAAA;AAuxBF;;AApxBA;EACE,8BAAA;AAuxBF;;AApxBA;EACE,oCAAA;EACA,qBAAA;AAuxBF;;AAnxBA;EACE,iBAAA;EACA,cAAA;EACA,gDAAA;AAsxBF;;AAlxBA;EACE,yBAAA;EACA,YAAA;AAqxBF;;AAlxBA;EACE,yBAAA;EACA,YAAA;AAqxBF;;AAlxBA;EACE,yBAAA;EACA,YAAA;AAqxBF;;AAlxBA;EACE,0BAAA;AAqxBF;;AAlxBA;EACE,oBAAA;AAqxBF;;AAlxBA;EAEE,yBAAA;AAoxBF;;AAjxBA;EACE,eAAA;AAoxBF;;AArwBA;EACE,aAAA;EACA,iBAAA;EACA,kCAAA;AAwwBF;;AApwBA;EACE,aAAA;EACA,2JAAA;EAEA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAswBF;AApwBE;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;AAswBJ;AApwBI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;AAswBN;AAnwBI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sCAAA;EACA,aAAA;EACA,YAAA;AAqwBN;AAjwBE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AAmwBJ;AAhwBE;EACE,mBAAA;AAkwBJ;AA/vBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,2CAAA;AAiwBJ;AA/vBI;EACE,eAAA;EACA,WAAA;AAiwBN;AA7vBE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AA+vBJ;AA5vBE;EACE,eAAA;EACA,+BAAA;EACA,SAAA;EACA,gBAAA;AA8vBJ;AA3vBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA6vBJ;AA1vBE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2CAAA;EACA,0BAAA;EACA,gCAAA;AA4vBJ;AA1vBI;EACE,oCAAA;AA4vBN;AAzvBI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA2vBN;AAzvBM;EACE,eAAA;EACA,gCAAA;AA2vBR;AAvvBI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAyvBN;AAtvBI;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;AAwvBN;AApvBE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;AAsvBJ;;AAjvBA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAovBF;;AAjvBA;EACE,WAAA;EACA,gBAAA;AAovBF;;AAjvBA;EACE,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAovBF;AAlvBE;EACE,yBAAA;AAovBJ;;AAhvBA;EACE,mBAAA;AAmvBF;;AAhvBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAmvBF;;AAhvBA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAmvBF;;AA/uBE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAkvBJ;;AA9uBA;EACE,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,yBAAA;AAivBF;AA/uBE;EACE,qBAAA;AAivBJ;AA9uBE;EAEE,qBAAA;EACA,4CAAA;AA+uBJ;AA5uBE;EACE,kBAAA;AA8uBJ;;AA1uBA;EACE,kBAAA;EACA,0BAAA;EACA,qBAAA;EACA,gBAAA;AA6uBF;;AA1uBA;EACE,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,wEAAA;EACA,uBAAA;EACA,wDAAA;EACA,oCAAA;AA6uBF;AA3uBE;EACE,wEAAA;EACA,wDAAA;EACA,2BAAA;AA6uBJ;AA1uBE;EACE,wBAAA;AA4uBJ;AAzuBE;EACE,8BAAA;EACA,2BAAA;EACA,mBAAA;AA2uBJ;;AAvuBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AA0uBF;;AAvuBA;EACE,kBAAA;AA0uBF;;AAvuBA;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;AA0uBF;AAxuBE;EACE,yBAAA;AA0uBJ;;AAtuBA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAyuBF;;AAruBA;EACE,WAAA;AAwuBF;;AAruBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,MAAA;AAwuBF;AAtuBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAwuBJ;AAtuBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AAwuBN;AAruBI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AAuuBN;AApuBI;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAsuBN;AApuBM;EACE,mBAAA;AAsuBR;AAjuBM;EACE,mBAAA;EACA,WAAA;EACA,2CAAA;AAmuBR;AAjuBM;EACE,cAAA;AAmuBR;AA9tBM;EACE,mBAAA;EACA,WAAA;AAguBR;AA9tBM;EACE,cAAA;AAguBR;;AA1tBA;EACE,kBAAA;EACA,mBAAA;AA6tBF;;AA1tBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA6tBF;AA3tBE;EACE,eAAA;EACA,WAAA;AA6tBJ;AA1tBE;EACE,6DAAA;AA4tBJ;;AAvtBA;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,oCAAA;EACA,oCAAA;AA0tBF;AAxtBE;EACE,gCAAA;EACA,sDAAA;AA0tBJ;AAvtBE;EACE,gCAAA;AAytBJ;AAttBE;EACE,gCAAA;AAwtBJ;;AAntBA;EACE;IACE,aAAA;IACA,aAAA;EAstBF;EAptBE;IACE,eAAA;EAstBJ;EAntBE;IACE,mBAAA;EAqtBJ;EAjtBA;IACE,aAAA;IACA,aAAA;EAmtBF;AACF;AAhtBA;EACE;IACE,sBAAA;EAktBF;EA/sBA;IACE,UAAA;IACA,kBAAA;IACA,gBAAA;EAitBF;EA/sBE;IACE,aAAA;EAitBJ;EA9sBE;IACE,gBAAA;IACA,kBAAA;EAgtBJ;EA7sBE;IACE,mBAAA;EA+sBJ;EA5sBE;IACE,kBAAA;EA8sBJ;EA3sBE;IACE,kBAAA;EA6sBJ;EA1sBE;IACE,aAAA;EA4sBJ;EAxsBA;IACE,SAAA;IACA,kBAAA;EA0sBF;AACF;AAvsBA;EACE;IACE,kBAAA;EAysBF;EAtsBA;IACE,sBAAA;IACA,uBAAA;IACA,0BAAA;EAwsBF;AACF;AArsBA,2CAAA;AAEA;EACE,UAAA,EAAA,oCAAA;EACA,WAAA,EAAA,uCAAA;AAssBF;;AAnsBA;EACE,mBAAA,EAAA,iCAAA;EACA,kBAAA,EAAA,sCAAA;AAssBF;;AAnsBA;EACE,gBAAA,EAAA,kCAAA;EACA,kBAAA,EAAA,uCAAA;AAssBF;;AAnsBA,oBAAA;AACA;EACE,gBAAA,EAAA,2CAAA;AAssBF;;AAnsBA;EACE,mDAAA;EACA,sBAAA;EACA,kCAAA;AAssBF","sourcesContent":["$primary: #00427a;\n$secondary: #006699;\n\n// @import \"../node_modules/bootstrap/scss/bootstrap\";\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n@import '~antd/dist/reset.css';\n\n// Global responsive rules for phones and tablets.\n@import './styles/responsive.scss';\n\n\n#components-layout-demo-side .logo {\n  height: 32px;\n  margin: 16px;\n  background: #0050b3;\n}\n\n.removeButtonRight {\n  right: 15px;\n  top: 15px;\n}\n\n.site-layout .site-layout-background {\n  background: #0050b3 !important;\n}\n\n.ant-menu .ant-menu-item-selected {\n  background-color: #0050b3 !important;\n  /*Overriden property*/\n}\n\n\n.ant-layout-footer {\n  padding: 5px 50px;\n  color: #001529;\n  background-color: #2b2e3168;\n\n}\n\n.ant-table-thead .ant-table-cell {\n  background-color: #0050b3;\n  color: white;\n}\n\n.ant-table-thead th.ant-table-column-sort {\n  background-color: #d0e5ff;\n  color: black;\n}\n\n.ant-table-thead th.ant-table-column-has-sorters:hover {\n  background-color: #d0e5ff;\n  color: black;\n}\n\n.ant-notification {\n  z-index: 100000 !important;\n}\n\n.ant-table-sticky-holder {\n  top: 3rem !important;\n}\n\n.custom-top {\n  // top: 4px !important;\n  background-color: #f0f2f5;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n// .beat {\n//   width: 10px;\n//   height: 30px;\n//   margin: 4px;\n//   background-color: #5cdd8b;\n//   border-radius: 15px;\n// }\n\n// ===================================\n// Login Page - Split Screen Layout\n// ===================================\n\n.login-page {\n  display: flex;\n  min-height: 100vh;\n  font-family: 'Poppins', sans-serif;\n}\n\n// Left Branding Panel\n.login-branding-panel {\n  flex: 0 0 55%;\n  background: linear-gradient(135deg, rgba(0, 66, 122, 0.92) 0%, rgba(0, 27, 58, 0.97) 100%),\n              url('assets/login_background.jpg') center center no-repeat;\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 60px;\n  position: relative;\n  overflow: hidden;\n\n  .branding-shapes {\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n\n    &::before {\n      content: '';\n      position: absolute;\n      width: 500px;\n      height: 500px;\n      border-radius: 50%;\n      background: rgba(255, 255, 255, 0.03);\n      top: -150px;\n      left: -150px;\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      width: 350px;\n      height: 350px;\n      border-radius: 50%;\n      background: rgba(255, 255, 255, 0.025);\n      bottom: -80px;\n      right: -80px;\n    }\n  }\n\n  .branding-content {\n    position: relative;\n    z-index: 1;\n    max-width: 480px;\n    width: 100%;\n  }\n\n  .branding-logo-section {\n    margin-bottom: 56px;\n  }\n\n  .branding-logo-icon {\n    width: 64px;\n    height: 64px;\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.12);\n    backdrop-filter: blur(10px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 24px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n\n    .anticon {\n      font-size: 32px;\n      color: #fff;\n    }\n  }\n\n  .branding-company-name {\n    font-size: 36px;\n    font-weight: 700;\n    color: #fff;\n    margin: 0 0 8px 0;\n    letter-spacing: -0.5px;\n  }\n\n  .branding-tagline {\n    font-size: 16px;\n    color: rgba(255, 255, 255, 0.6);\n    margin: 0;\n    font-weight: 300;\n  }\n\n  .branding-features {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .branding-feature-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 16px 20px;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    backdrop-filter: blur(4px);\n    transition: background 0.3s ease;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.1);\n    }\n\n    .feature-icon {\n      flex-shrink: 0;\n      width: 40px;\n      height: 40px;\n      border-radius: 10px;\n      background: rgba(255, 255, 255, 0.1);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      .anticon {\n        font-size: 18px;\n        color: rgba(255, 255, 255, 0.85);\n      }\n    }\n\n    .feature-title {\n      font-size: 14px;\n      font-weight: 600;\n      color: #fff;\n      margin-bottom: 2px;\n    }\n\n    .feature-desc {\n      font-size: 13px;\n      color: rgba(255, 255, 255, 0.5);\n      font-weight: 300;\n    }\n  }\n\n  .branding-footer {\n    position: absolute;\n    bottom: 32px;\n    left: 0;\n    right: 0;\n    text-align: center;\n  }\n}\n\n// Right Form Panel\n.login-form-panel {\n  flex: 0 0 45%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 60px;\n  background: #f8fafc;\n  position: relative;\n  overflow-y: auto;\n}\n\n.login-form-container {\n  width: 100%;\n  max-width: 400px;\n}\n\n.login-back-btn {\n  color: #64748b !important;\n  padding: 0 !important;\n  margin-bottom: 24px;\n  font-size: 14px;\n  height: auto !important;\n\n  &:hover {\n    color: #0050b3 !important;\n  }\n}\n\n.login-form-header {\n  margin-bottom: 32px;\n}\n\n.login-email-badge {\n  display: flex;\n  align-items: center;\n  padding: 10px 16px;\n  background: #e8f4fd;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-size: 13px;\n  color: #0050b3;\n  font-weight: 500;\n}\n\n.login-otp-info {\n  padding: 12px 16px;\n  background: #f0f7ff;\n  border-radius: 8px;\n  border-left: 3px solid #0050b3;\n  margin-bottom: 20px;\n  font-size: 13px;\n  color: #334155;\n}\n\n.login-form {\n  .ant-form-item-label > label {\n    font-weight: 500;\n    color: #334155;\n    font-size: 13px;\n  }\n}\n\n.login-input {\n  height: 48px;\n  border-radius: 10px;\n  border: 1.5px solid #e2e8f0;\n  font-size: 15px;\n  transition: all 0.2s ease;\n\n  &:hover {\n    border-color: #94b8d6;\n  }\n\n  &:focus,\n  &.ant-input-affix-wrapper-focused {\n    border-color: #0050b3;\n    box-shadow: 0 0 0 3px rgba(0, 80, 179, 0.08);\n  }\n\n  .ant-input-prefix {\n    margin-right: 10px;\n  }\n}\n\n.login-otp-input {\n  text-align: center;\n  font-size: 22px !important;\n  letter-spacing: 0.5em;\n  font-weight: 600;\n}\n\n.login-submit-btn {\n  height: 48px !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  border-radius: 10px !important;\n  background: linear-gradient(135deg, #0050b3 0%, #003175 100%) !important;\n  border: none !important;\n  box-shadow: 0 4px 12px rgba(0, 80, 179, 0.25) !important;\n  transition: all 0.3s ease !important;\n\n  &:hover:not(:disabled) {\n    background: linear-gradient(135deg, #0066d6 0%, #004399 100%) !important;\n    box-shadow: 0 6px 20px rgba(0, 80, 179, 0.35) !important;\n    transform: translateY(-1px);\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(0);\n  }\n\n  &:disabled {\n    background: #cbd5e1 !important;\n    box-shadow: none !important;\n    cursor: not-allowed;\n  }\n}\n\n.login-error {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 10px 16px;\n  color: #dc2626;\n  font-size: 13px;\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.login-actions {\n  text-align: center;\n}\n\n.login-link {\n  color: #0050b3 !important;\n  font-weight: 500;\n  font-size: 13px;\n  padding: 4px 0 !important;\n  height: auto !important;\n\n  &:hover {\n    color: #003175 !important;\n  }\n}\n\n.login-form-footer {\n  text-align: center;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #e2e8f0;\n}\n\n// Password Reset Embedded\n.reset-embedded {\n  width: 100%;\n}\n\n.reset-step-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 32px;\n  gap: 0;\n\n  .reset-step {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n\n    .reset-step-dot {\n      width: 28px;\n      height: 28px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 12px;\n      font-weight: 600;\n      background: #e2e8f0;\n      color: #94a3b8;\n      transition: all 0.3s ease;\n    }\n\n    .reset-step-label {\n      font-size: 12px;\n      color: #94a3b8;\n      font-weight: 500;\n      transition: all 0.3s ease;\n    }\n\n    .reset-step-line {\n      width: 32px;\n      height: 2px;\n      background: #e2e8f0;\n      margin: 0 8px;\n      transition: all 0.3s ease;\n\n      &.complete {\n        background: #0050b3;\n      }\n    }\n\n    &.active {\n      .reset-step-dot {\n        background: #0050b3;\n        color: #fff;\n        box-shadow: 0 2px 8px rgba(0, 80, 179, 0.3);\n      }\n      .reset-step-label {\n        color: #0050b3;\n      }\n    }\n\n    &.complete {\n      .reset-step-dot {\n        background: #0050b3;\n        color: #fff;\n      }\n      .reset-step-label {\n        color: #0050b3;\n      }\n    }\n  }\n}\n\n.reset-header {\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.reset-icon-circle {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #0050b3 0%, #003175 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n\n  .anticon {\n    font-size: 24px;\n    color: #fff;\n  }\n\n  &.success {\n    background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  }\n}\n\n// OTP Digit Inputs\n.otp-digit-input {\n  width: 48px !important;\n  height: 56px !important;\n  text-align: center !important;\n  font-size: 22px !important;\n  font-weight: 700 !important;\n  border-radius: 10px !important;\n  border: 2px solid #e2e8f0 !important;\n  transition: all 0.2s ease !important;\n\n  &:focus {\n    border-color: #0050b3 !important;\n    box-shadow: 0 0 0 3px rgba(0, 80, 179, 0.1) !important;\n  }\n\n  &:hover {\n    border-color: #94b8d6 !important;\n  }\n\n  &.otp-error {\n    border-color: #ef4444 !important;\n  }\n}\n\n// Responsive\n@media (max-width: 992px) {\n  .login-branding-panel {\n    flex: 0 0 45%;\n    padding: 40px;\n\n    .branding-company-name {\n      font-size: 28px;\n    }\n\n    .branding-logo-section {\n      margin-bottom: 40px;\n    }\n  }\n\n  .login-form-panel {\n    flex: 0 0 55%;\n    padding: 40px;\n  }\n}\n\n@media (max-width: 768px) {\n  .login-page {\n    flex-direction: column;\n  }\n\n  .login-branding-panel {\n    flex: none;\n    padding: 40px 24px;\n    min-height: auto;\n\n    .branding-features {\n      display: none;\n    }\n\n    .branding-logo-section {\n      margin-bottom: 0;\n      text-align: center;\n    }\n\n    .branding-logo-icon {\n      margin: 0 auto 16px;\n    }\n\n    .branding-company-name {\n      text-align: center;\n    }\n\n    .branding-tagline {\n      text-align: center;\n    }\n\n    .branding-footer {\n      display: none;\n    }\n  }\n\n  .login-form-panel {\n    flex: 1;\n    padding: 32px 24px;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-form-panel {\n    padding: 24px 16px;\n  }\n\n  .otp-digit-input {\n    width: 40px !important;\n    height: 48px !important;\n    font-size: 18px !important;\n  }\n}\n\n/* Style the scrollbar for a specific div */\n\n.custom-scroll-div::-webkit-scrollbar {\n  width: 5px; /* Width of the vertical scrollbar */\n  height: 5px; /* Height of the horizontal scrollbar */\n}\n\n.custom-scroll-div::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Color of the scrollbar track */\n  border-radius: 5px; /* Roundness of the track (optional) */\n}\n\n.custom-scroll-div::-webkit-scrollbar-thumb {\n  background: #888; /* Color of the scrollbar handle */\n  border-radius: 5px; /* Roundness of the handle (optional) */\n}\n\n/* Handle on hover */\n.custom-scroll-div::-webkit-scrollbar-thumb:hover {\n  background: #555; /* Color of the scrollbar handle on hover */\n}\n\n.chat-background {\n  background: url(\"assets/chat-background.jpg\");\n  background-size: cover;\n  background-position: center center;\n}","/* =============================================================================\n   Global responsive layer\n   -----------------------------------------------------------------------------\n   Breakpoints (aligned with antd + the Sider's `lg` collapse point):\n     phone   : <= 575px\n     tablet  : 576px - 991px\n     desktop : >= 992px\n\n   This file adapts the shared Ant Design surface (tables, forms, grid, modals,\n   drawers, cards, pagination) so individual pages do not each need bespoke\n   mobile handling. Page-specific tweaks still live with their component.\n   ========================================================================== */\n\n$phone: 575px;\n$tablet-min: 576px;\n$tablet-max: 991px;\n\n/* -----------------------------------------------------------------------------\n   1. Document — never let the page scroll sideways.\n   Wide content (tables, editors) scrolls inside its own container instead.\n   -------------------------------------------------------------------------- */\n@media (max-width: $tablet-max) {\n  html,\n  body {\n    max-width: 100%;\n    overflow-x: hidden;\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   1b. Safe areas (installed home-screen app on notched iPhones).\n   `viewport-fit=cover` in index.html lets the page paint edge to edge; these\n   insets keep the actual content out from under the status bar, the notch and\n   the home indicator. They resolve to 0px everywhere else, so the rules are\n   harmless in a normal browser tab.\n   -------------------------------------------------------------------------- */\n/* Only the installed app paints behind the status bar, so only it needs the\n   strip filled to match the header. Scoping this to standalone keeps the\n   normal browser pages (login included) on their own background. */\n@media (display-mode: standalone) {\n  body {\n    background-color: #001529;\n  }\n}\n\n.app-header {\n  padding-top: env(safe-area-inset-top);\n  padding-left: max(10px, env(safe-area-inset-left));\n  padding-right: max(10px, env(safe-area-inset-right));\n  height: calc(50px + env(safe-area-inset-top));\n  box-sizing: border-box;\n}\n\n.app-content {\n  padding-left: env(safe-area-inset-left);\n  padding-right: env(safe-area-inset-right);\n  padding-bottom: env(safe-area-inset-bottom);\n}\n\n.ant-layout-footer {\n  padding-bottom: calc(24px + env(safe-area-inset-bottom));\n}\n\n/* Bottom sheets and drawers must clear the home indicator too. */\n.ant-drawer-bottom .ant-drawer-content {\n  padding-bottom: env(safe-area-inset-bottom);\n}\n\n.ant-drawer-left .ant-drawer-body {\n  padding-bottom: env(safe-area-inset-bottom);\n}\n\n/* An installed app has no browser chrome to absorb an overscroll bounce. */\n@media (display-mode: standalone) {\n  html,\n  body {\n    overscroll-behavior-y: none;\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   2. App shell\n   -------------------------------------------------------------------------- */\n.app-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 50px;\n  padding: 0 10px;\n  overflow: hidden;\n}\n\n/* Hamburger is desktop-hidden: the Sider is visible there. */\n.app-nav-trigger {\n  display: none;\n}\n\n/* `collapsedWidth=\"0\"` makes antd render a floating 40px trigger tab pinned to\n   the Sider's right edge. While the Sider is expanded that tab sits on top of\n   the page content (over the breadcrumb) and duplicates the Sider's own bottom\n   trigger — so only show it when it is actually needed to bring the collapsed\n   Sider back. */\n.ant-layout-sider:not(.ant-layout-sider-collapsed)\n  .ant-layout-sider-zero-width-trigger {\n  display: none;\n}\n\n.app-nav-drawer {\n  .ant-drawer-body {\n    padding: 0;\n    background: #001529;\n  }\n  .ant-drawer-header {\n    background: #001529;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n  }\n  .ant-drawer-title,\n  .ant-drawer-close {\n    color: rgba(255, 255, 255, 0.88);\n  }\n}\n\n@media (max-width: $tablet-max) {\n  .app-nav-trigger {\n    display: inline-flex;\n  }\n\n  /* Below `lg` the nav is a drawer opened from the header hamburger, so the\n     Sider's own floating trigger has nothing to toggle. */\n  .ant-layout-sider-zero-width-trigger {\n    display: none !important;\n  }\n\n  .app-content {\n    padding: 0 !important;\n  }\n\n  .ant-layout-footer {\n    padding: 10px 12px;\n    font-size: 12px;\n  }\n}\n\n/* Header: drop the lowest-value items first as width runs out —\n   the clock goes on tablets, the session countdown on phones. */\n@media (max-width: $tablet-max) {\n  .app-header-clock {\n    display: none !important;\n  }\n}\n\n@media (max-width: $phone) {\n  .app-header-session {\n    display: none !important;\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   3. Grid — stack columns that carry no explicit responsive props.\n   Columns that already declare `xs`/`sm`/`md` are left untouched so existing\n   deliberate layouts keep winning.\n   -------------------------------------------------------------------------- */\n/* NOTE: `.ant-form-item-row` is itself an `.ant-row`, and a Form's\n   labelCol/wrapperCol render as `.ant-col-*` children of it. Those must be\n   excluded here or every horizontal form breaks — form label stacking is\n   handled separately in section 4. */\n@media (max-width: $phone) {\n  .ant-row:not(.ant-form-item-row)\n    > .ant-col:not([class*=\"ant-col-xs-\"]):not([style*=\"flex\"]) {\n    flex: 0 0 100% !important;\n    max-width: 100% !important;\n  }\n\n  /* Offsets designed for a wide grid only create dead space once stacked. */\n  .ant-row:not(.ant-form-item-row)\n    > .ant-col[class*=\"ant-col-offset-\"]:not([class*=\"ant-col-xs-offset-\"]) {\n    margin-inline-start: 0 !important;\n  }\n}\n\n@media (min-width: $tablet-min) and (max-width: $tablet-max) {\n  $tablet-exclude: ':not([class*=\"ant-col-sm-\"]):not([class*=\"ant-col-md-\"]):not([style*=\"flex\"])';\n\n  /* 6-across and tighter -> 3-across */\n  @for $i from 1 through 4 {\n    .ant-row:not(.ant-form-item-row) > .ant-col-#{$i}#{$tablet-exclude} {\n      flex: 0 0 33.33333333% !important;\n      max-width: 33.33333333% !important;\n    }\n  }\n\n  /* 4- and 3-across -> 2-across */\n  @for $i from 5 through 8 {\n    .ant-row:not(.ant-form-item-row) > .ant-col-#{$i}#{$tablet-exclude} {\n      flex: 0 0 50% !important;\n      max-width: 50% !important;\n    }\n  }\n\n  /* Anything narrower than half width -> full width */\n  @for $i from 9 through 11 {\n    .ant-row:not(.ant-form-item-row) > .ant-col-#{$i}#{$tablet-exclude} {\n      flex: 0 0 100% !important;\n      max-width: 100% !important;\n    }\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   4. Forms — labels move above their field on phones.\n   -------------------------------------------------------------------------- */\n@media (max-width: $phone) {\n  .ant-form-horizontal .ant-form-item-row {\n    flex-direction: column;\n  }\n\n  .ant-form-horizontal .ant-form-item-label {\n    flex: 0 0 auto !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    text-align: left !important;\n    padding: 0 0 4px !important;\n\n    > label {\n      height: auto;\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  .ant-form-horizontal .ant-form-item-control {\n    flex: 1 1 auto !important;\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n}\n\n/* Inline forms (filter bars) wrap instead of overflowing. */\n@media (max-width: $tablet-max) {\n  .ant-form-inline {\n    row-gap: 8px;\n\n    .ant-form-item {\n      margin-inline-end: 8px;\n    }\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   5. Form controls — honour hard-coded pixel widths only when they fit.\n   Many pages set e.g. `style={{ width: 300 }}`; capping max-width lets those\n   shrink on narrow screens without touching every call site.\n   -------------------------------------------------------------------------- */\n@media (max-width: $tablet-max) {\n  .ant-input,\n  .ant-input-affix-wrapper,\n  .ant-input-number,\n  .ant-input-search,\n  .ant-picker,\n  .ant-select,\n  .ant-cascader,\n  .ant-tree-select,\n  .ant-mentions,\n  .ant-slider,\n  .ant-radio-group,\n  .ant-checkbox-group,\n  .ant-upload-wrapper,\n  .ant-segmented {\n    max-width: 100% !important;\n  }\n\n  /* Range pickers are the most common horizontal overflow source. */\n  .ant-picker-range {\n    width: 100% !important;\n  }\n}\n\n@media (max-width: $phone) {\n  /* Comfortable touch targets without inflating inline/link buttons. */\n  .ant-btn:not(.ant-btn-link):not(.ant-btn-text):not(.ant-btn-sm) {\n    min-height: 36px;\n  }\n\n  .ant-input,\n  .ant-select-single .ant-select-selector,\n  .ant-picker {\n    font-size: 16px; /* prevents iOS Safari zoom-on-focus */\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   6. Tables — scroll horizontally inside the wrapper, never the page.\n   -------------------------------------------------------------------------- */\n@media (max-width: $tablet-max) {\n  .ant-table-wrapper {\n    max-width: 100%;\n  }\n\n  /* Safety net for tables declared without a `scroll` prop. */\n  .ant-table-content,\n  .ant-table-body {\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* When a Table has no `scroll.x`, antd renders it under `.ant-table-content`\n     and lets the columns compress to the container width — which turns into\n     overlapping, unreadable text on a phone. Giving those tables their natural\n     width makes them scroll horizontally like the configured ones. Tables that\n     DO set `scroll` render under `.ant-table-header`/`.ant-table-body`, so they\n     are untouched. */\n  .ant-table-content > table {\n    min-width: max-content;\n    /* `table-layout: fixed` would keep the authored column widths and let the\n       no-wrap cell text spill across neighbouring columns. */\n    table-layout: auto !important;\n  }\n\n  .ant-table {\n    font-size: 12px;\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 8px !important;\n    white-space: nowrap;\n  }\n\n  /* Row action clusters stay on one line so rows stay compact — the table\n     already scrolls horizontally. `!important` is needed because the generic\n     \"wrap long toolbars\" rules further down would otherwise stack them. */\n  .ant-table-tbody .ant-space:not(.ant-space-vertical),\n  .ant-table-tbody .ant-flex:not(.ant-flex-vertical) {\n    flex-wrap: nowrap !important;\n  }\n\n  .ant-table-title,\n  .ant-table-footer {\n    padding: 8px !important;\n  }\n}\n\n@media (max-width: $phone) {\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 6px !important;\n  }\n}\n\n/* Pagination wraps and centres rather than pushing the layout wide. */\n@media (max-width: $tablet-max) {\n  .ant-pagination {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    row-gap: 8px;\n  }\n\n  .ant-pagination-total-text {\n    width: 100%;\n    text-align: center;\n    margin-inline-end: 0;\n  }\n}\n\n@media (max-width: $phone) {\n  .ant-pagination-options-quick-jumper {\n    display: none !important;\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   7. Modals & drawers — full-bleed on phones.\n   -------------------------------------------------------------------------- */\n@media (max-width: $tablet-max) {\n  .ant-modal {\n    max-width: calc(100vw - 32px) !important;\n  }\n}\n\n@media (max-width: $phone) {\n  .ant-modal {\n    max-width: calc(100vw - 16px) !important;\n    margin: 8px auto !important;\n    top: 8px !important;\n    padding-bottom: 8px;\n  }\n\n  .ant-modal-body {\n    max-height: calc(100vh - 180px);\n    overflow-y: auto;\n  }\n\n  .ant-modal-footer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n\n    .ant-btn {\n      flex: 1 1 auto;\n      margin-inline-start: 0 !important;\n    }\n  }\n}\n\n/* Drawers: full width on phones, comfortable on tablets.\n   `.app-nav-drawer` keeps its own narrow width. */\n@media (max-width: $phone) {\n  .ant-drawer-left:not(.app-nav-drawer) .ant-drawer-content-wrapper,\n  .ant-drawer-right:not(.app-nav-drawer) .ant-drawer-content-wrapper {\n    width: 100vw !important;\n    max-width: 100vw !important;\n  }\n}\n\n@media (min-width: $tablet-min) and (max-width: $tablet-max) {\n  .ant-drawer-left:not(.app-nav-drawer) .ant-drawer-content-wrapper,\n  .ant-drawer-right:not(.app-nav-drawer) .ant-drawer-content-wrapper {\n    max-width: 90vw !important;\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   CKEditor 4.\n   Several editor configs pin a physical page width — `width: \"21cm\"` in the\n   invoice, quote and template editors, `\"19cm\"` in account notes — which\n   CKEditor writes as an inline style on `.cke`. 21cm is ~794px, so the box is\n   wider than its container on any phone, and inside a drawer or a half-width\n   column on a desktop too.\n\n   `max-width` always wins over `width`, so the page width still applies\n   wherever there is room for it and collapses where there is not — the\n   template editors keep their document look without spilling out of the box\n   everywhere else. Matching rules for the editing body live in\n   public/ckeditor-content.css, which is loaded into the editor's iframe.\n   -------------------------------------------------------------------------- */\n.cke,\n.cke_chrome,\n.cke_editor {\n  max-width: 100% !important;\n  box-sizing: border-box;\n}\n\n.cke_inner,\n.cke_top,\n.cke_contents,\n.cke_bottom {\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* The toolbar wraps to as many rows as it needs; it must never set a floor on\n   the editor's width. */\n.cke_top {\n  white-space: normal;\n}\n\n/* CKEditor is usually a flex child (Form.Item content, Space, Col). Flex items\n   default to `min-width: auto`, which stops the parent shrinking below the\n   editor's intrinsic width and pushes the overflow up the tree. */\n.ant-form-item-control-input-content,\n.ant-col:has(> .cke),\n.cke-resize-wrap {\n  min-width: 0;\n}\n\n/* The elements path (\"body > p > strong\") in the footer can run long. */\n.cke_path {\n  overflow: hidden;\n}\n\n@media (max-width: $phone) {\n  /* The button set is already cut down in `compactToolbar()`; this squeezes the\n     remaining chrome so the toolbar costs one row rather than three, and the\n     text area starts near the top of the box. */\n  .cke_top {\n    padding: 4px 4px 2px;\n  }\n\n  .cke_toolbar,\n  .cke_toolgroup,\n  .cke_combo {\n    margin: 0 4px 2px 0;\n  }\n\n  .cke_button {\n    padding: 4px 5px;\n  }\n\n  .cke_button__source_label,\n  .cke_button_label {\n    display: none;\n  }\n\n  /* The elements path is a desktop affordance and costs a whole row. The\n     resizer stays; only the breadcrumb goes. */\n  .cke_path {\n    display: none;\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   Filter bar: search on the left, a single Filter button on the right.\n   Everything else lives in the modal/sheet behind that button, so the table\n   keeps the vertical space that a row of wrapped selects used to eat.\n   -------------------------------------------------------------------------- */\n.filter-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  /* Several toolbars nest the bar inside an existing <Flex> row; these let it\n     take the free space there instead of collapsing to its content width.\n     Ignored when the parent is not a flex container. */\n  flex: 1 1 320px;\n  min-width: 0;\n\n  .filter-bar-search {\n    flex: 1 1 auto;\n    max-width: 420px;\n  }\n\n  .filter-bar-actions {\n    flex: 0 0 auto;\n    margin-left: auto;\n  }\n}\n\n/* Applied filters, one removable chip each, sitting between the bar and the\n   table so what is narrowing the list is visible without opening the modal. */\n.filter-bar-tags {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin: -8px 0 12px;\n\n  .ant-tag {\n    margin-inline-end: 0;\n  }\n\n  .filter-bar-clear {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: $phone) {\n  .filter-bar {\n    gap: 8px;\n\n    .filter-bar-search {\n      max-width: none;\n    }\n  }\n}\n\n/* Every control in the panel spans the full width so the filters line up and\n   stay comfortably tappable. */\n.filter-panel {\n  .filter-field-control {\n    > .ant-select,\n    > .ant-picker,\n    > .ant-input,\n    > .ant-input-affix-wrapper,\n    > .ant-input-number,\n    > .ant-radio-group,\n    > .ant-cascader,\n    > .ant-tree-select {\n      width: 100% !important;\n    }\n  }\n}\n\n/* Drawer header: the title must be allowed to shrink (and ellipsize) so the\n   action buttons in `extra` are never pushed past the edge or overlapped.\n   Actions belong in `extra`, never inside `title` — see PreviewDrawerActions. */\n.ant-drawer-header:not(.app-nav-drawer .ant-drawer-header) {\n  gap: 8px;\n\n  .ant-drawer-header-title {\n    min-width: 0;\n    overflow: hidden;\n  }\n\n  .ant-drawer-title {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .ant-drawer-extra {\n    flex: 0 0 auto;\n    white-space: nowrap;\n  }\n}\n\n@media (max-width: $phone) {\n  .ant-drawer-header {\n    padding: 12px;\n  }\n\n  .ant-drawer-body {\n    padding: 16px 12px;\n  }\n\n  .ant-drawer-footer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   8. Cards, descriptions, tabs and other content containers.\n   -------------------------------------------------------------------------- */\n@media (max-width: $phone) {\n  .ant-card-body {\n    padding: 12px !important;\n  }\n\n  .ant-card-head {\n    padding: 0 12px !important;\n    min-height: 44px;\n  }\n\n  .ant-card-head-wrapper {\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 8px 0;\n  }\n\n  /* antd truncates card titles with `white-space: nowrap; overflow: hidden`,\n     which cuts long titles off entirely on a narrow screen. Let them wrap. */\n  .ant-card-head-title {\n    white-space: normal;\n    overflow: visible;\n    text-overflow: clip;\n    padding: 0;\n\n    .ant-space {\n      flex-wrap: wrap;\n    }\n\n    .ant-typography,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      white-space: normal;\n      overflow-wrap: anywhere;\n    }\n  }\n\n  .ant-card-extra {\n    margin-inline-start: 0;\n    padding: 0;\n    width: 100%;\n  }\n\n  .ant-statistic-content {\n    font-size: 18px;\n  }\n}\n\n/* Descriptions collapse to a single column on phones, two on tablets. */\n@media (max-width: $phone) {\n  .ant-descriptions-view table,\n  .ant-descriptions-view tbody,\n  .ant-descriptions-row {\n    display: block !important;\n    width: 100% !important;\n  }\n\n  .ant-descriptions-row > th,\n  .ant-descriptions-row > td {\n    display: block !important;\n    width: 100% !important;\n    padding: 8px 12px !important;\n  }\n\n  .ant-descriptions-item-label {\n    font-weight: 600;\n  }\n}\n\n/* Tab bars: antd already collapses overflowing tabs into a \"more\" dropdown,\n   so only tighten the spacing here — overriding the nav wrap's overflow would\n   break that measurement and let the tab list run off-screen. */\n@media (max-width: $tablet-max) {\n  .ant-tabs-nav {\n    max-width: 100%;\n  }\n\n  .ant-tabs-tab {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n}\n\n/* Long inline toolbars wrap. */\n@media (max-width: $tablet-max) {\n  .ant-space:not(.ant-space-vertical) {\n    flex-wrap: wrap;\n  }\n\n  .ant-page-header-heading {\n    flex-wrap: wrap;\n    row-gap: 8px;\n  }\n}\n\n/* Headings scale down so they stop forcing horizontal overflow. */\n@media (max-width: $phone) {\n  h1,\n  .ant-typography h1 {\n    font-size: 22px !important;\n  }\n  h2,\n  .ant-typography h2 {\n    font-size: 19px !important;\n  }\n  h3,\n  .ant-typography h3 {\n    font-size: 17px !important;\n  }\n\n  .ant-breadcrumb {\n    font-size: 12px;\n  }\n\n  /* Long unbroken values (emails, IDs, URLs) must not widen the page. */\n  .ant-descriptions-item-content,\n  .ant-list-item-meta-description,\n  .ant-typography {\n    overflow-wrap: anywhere;\n  }\n}\n\n/* Wide rich-content blocks scroll inside themselves. */\n@media (max-width: $tablet-max) {\n  .ck-editor,\n  .ck-editor__editable,\n  .quill,\n  .ql-container,\n  pre,\n  .ant-typography pre {\n    max-width: 100% !important;\n  }\n\n  .ck.ck-toolbar {\n    flex-wrap: wrap;\n  }\n\n  .editor-container_document-editor .editor-container__editor .ck.ck-editor__editable {\n    min-width: 0 !important;\n    max-width: 100% !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    padding: 12px !important;\n  }\n\n  .main-container,\n  .editor-container__editor-wrapper {\n    width: 100% !important;\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   9. Page-level containers\n   -------------------------------------------------------------------------- */\n.dashboard-page {\n  padding: 16px 24px;\n}\n\n@media (max-width: $tablet-max) {\n  .dashboard-page {\n    padding: 12px;\n  }\n}\n\n@media (max-width: $phone) {\n  .dashboard-page {\n    padding: 10px;\n  }\n}\n\n/* Title-plus-actions bars wrap instead of crushing the heading. */\n@media (max-width: $tablet-max) {\n  .page-header-bar {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   10. List-page toolbars\n   The primary actions on list screens each get their own full-width row on a\n   phone rather than being squeezed onto one line.\n   (These rules previously lived in `<style>` expressions that never rendered.)\n   -------------------------------------------------------------------------- */\n@media (max-width: $phone) {\n  .add-account-btn,\n  .add-contact-btn,\n  .export-contacts-btn,\n  .add-lead-btn,\n  .send-email-btn,\n  .send-whatsapp-btn,\n  .add-payment-btn,\n  .update-payments-btn,\n  .refresh-teson-btn,\n  .refresh-product-btn,\n  .create-invoice-btn,\n  .create-quote-btn {\n    width: 100% !important;\n    margin-right: 0 !important;\n  }\n}\n\n/* Forms inside drawers/modals must not carry a desktop min-width. */\n@media (max-width: $tablet-max) {\n  .ant-form {\n    min-width: 0 !important;\n  }\n}\n\n/* Headings in a wrapping toolbar should push the actions onto the next line\n   rather than being squeezed into a narrow, multi-line column. */\n@media (max-width: $tablet-max) {\n  .ant-flex > h1.ant-typography,\n  .ant-flex > h2.ant-typography,\n  .ant-flex > h3.ant-typography,\n  .ant-flex > h4.ant-typography,\n  .ant-flex > h5.ant-typography,\n  .page-header-bar > h1.ant-typography,\n  .page-header-bar > h2.ant-typography,\n  .page-header-bar > h3.ant-typography {\n    flex: 0 0 auto;\n    max-width: 100%;\n  }\n}\n\n/* -----------------------------------------------------------------------------\n   11. Flex toolbars\n   `<Flex justify=\"space-between\">` bars pair a filter cluster with an action\n   cluster. Without wrapping, the action cluster is pushed off-screen on narrow\n   viewports, so allow these to wrap (containers that opt out with\n   `wrap=\"nowrap\"` are respected).\n   -------------------------------------------------------------------------- */\n@media (max-width: $tablet-max) {\n  .ant-flex-justify-space-between:not(.ant-flex-wrap-nowrap),\n  .ant-flex-justify-flex-end:not(.ant-flex-wrap-nowrap),\n  .ant-flex-justify-end:not(.ant-flex-wrap-nowrap),\n  .ant-flex-justify-space-around:not(.ant-flex-wrap-nowrap) {\n    flex-wrap: wrap;\n    row-gap: 8px;\n  }\n}\n\n/* On phones every horizontal Flex cluster may wrap, so trailing controls are\n   never pushed off-screen. Containers that opt out (`wrap=\"nowrap\"`), vertical\n   stacks, and deliberate horizontal-scroll strips (kanban) are left alone. */\n@media (max-width: $phone) {\n  .ant-flex:not(.ant-flex-wrap-nowrap):not(.ant-flex-vertical):not([style*=\"overflow\"]) {\n    flex-wrap: wrap;\n    row-gap: 8px;\n  }\n}\n\n/* Space items default to not shrinking, which lets a long title overflow.\n   Allowing them to shrink lets the text wrap instead. */\n@media (max-width: $phone) {\n  .ant-space-item {\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
